var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { FilledInput, InputAdornment } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
export const FilteredInput = (_a) => {
    var { endIcon, sx } = _a, props = __rest(_a, ["endIcon", "sx"]);
    const theme = useTheme();
    return (React.createElement(FilledInput, Object.assign({}, props, { disableUnderline: true, hiddenLabel: true, size: "medium", endAdornment: endIcon && (React.createElement(InputAdornment, { position: "end", sx: { gap: 0.5, display: "flex" } }, endIcon)), sx: Object.assign({ height: 45, borderRadius: "40px", border: "1px solid", color: theme.palette.text.tertiary, borderColor: (theme) => alpha(theme.palette.primary.main, 0.3), backgroundColor: "background.paper", "&:hover": {
                borderColor: (theme) => alpha(theme.palette.primary.main, 0.5),
            }, "&.Mui-focused": {
                borderColor: (theme) => theme.palette.primary.main,
            }, "& .MuiFilledInput-input": {
                padding: "12px 16px",
            } }, sx) })));
};
